import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable, Injector } from '@angular/core'
import { EMPTY, Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { OpenAuthenticationService } from '@core/services/oauth.service'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  // Resolve the auth service lazily via the Injector (not constructor injection) to avoid a DI cycle:
  // OpenAuthenticationService → OAuthService → HttpClient → HTTP_INTERCEPTORS (this).
  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<Request>,
    next: HttpHandler
  ): Observable<HttpEvent<Event>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          // Token rejected/expired → kick off a clean re-authentication (redirect to login, returning here
          // afterward) rather than leaving the UI half-broken. Swallow the error since we're navigating away
          // (and it's guarded, so concurrent 401s only redirect once).
          this.injector.get(OpenAuthenticationService).reauthenticate()
          return EMPTY
        }
        if (err.status === 404) {
          const error = "Unable to perform this operation due to a problem in locating the requested resource.";
          return throwError(error);
        }
        const error = err.error.errors.length > 0 ? err.error.errors[0].message || err.error.errors[0] : err.statusText
        return throwError(error)
      })
    )
  }
}
